document.addEventListener("DOMContentLoaded", function() {
  // Accordion-effect voor kleinere schermen
  if (window.innerWidth > 992) {
    document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem) {
        everyitem.addEventListener('mouseover', function(e) {
            let el_link = this.querySelector('i[data-bs-toggle]');
            if (el_link != null) {
                let nextEl = el_link.nextElementSibling;
                el_link.classList.add('show');
                el_link.classList.add('fa-chevron-up');
                el_link.classList.remove('fa-chevron-down');
                nextEl.setAttribute('data-bs-popper', 'none');
                nextEl.classList.add('show');
            }
        });
        everyitem.addEventListener('mouseleave', function(e) {
            let el_link = this.querySelector('i[data-bs-toggle]');
            if (el_link != null) {
                let nextEl = el_link.nextElementSibling;
                el_link.classList.remove('show');
                el_link.classList.add('fa-chevron-down');
                el_link.classList.remove('fa-chevron-up');
                nextEl.classList.remove('show');
                nextEl.removeAttribute('data-bs-popper');
            }
        });
    });
}
document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem) {
everyitem.addEventListener('click', function() {
  let el_link = this.querySelector('i[data-bs-toggle]');
  if (el_link != null) {
    let el_icon = el_link.classList.contains('fa-chevron-down');
    if(el_icon == true){
      el_link.classList.add('fa-chevron-up');
      el_link.classList.remove('fa-chevron-down');
    } else{
      el_link.classList.add('fa-chevron-down');
      el_link.classList.remove('fa-chevron-up');
    }
  }
});
});

  // Button voor het verplaatsen van pagina
  document.querySelectorAll('.about-btn').forEach(btn => {
      btn.addEventListener('click', function() {
          let Hero = document.querySelector('.wp-block-acf-about-hero-block');
          let Heroheight = Hero.clientHeight;
          window.scrollBy(0, Heroheight);
      });
  });

  // Automatisch afspelen van video
  // videohero = document.querySelector('#videohero');
  // videohero.play();
});
    // DOMContentLoaded  end

    //video lazyload according to web.dev
    document.addEventListener("DOMContentLoaded", function() {
        var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
      
        if ("IntersectionObserver" in window) {
          var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
              if (video.isIntersecting) {
                for (var source in video.target.children) {
                  var videoSource = video.target.children[source];
                  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                    videoSource.src = videoSource.dataset.src;
                  }
                }
      
                video.target.load();
                video.target.classList.remove("lazy");
                lazyVideoObserver.unobserve(video.target);
              }
            });
          });
      
          lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
          });
        }
      });

// Class geven aan blogpage actieve pagina
document.addEventListener('DOMContentLoaded', function() {
  var currentUrl = window.location.href;

  // Loop through each menu item
  var menuItems = document.querySelectorAll('.navbar-nav li a');
  menuItems.forEach(function(menuItem) {
    var menuItemUrl = menuItem.getAttribute('href');

    // Check if the current URL matches the menu item URL
    if (currentUrl === menuItemUrl) {
      // Add the 'active' class to the <a> element
      menuItem.classList.add('active');

      // If the menu item has a dropdown, also add the 'active' class to its parent <li> element
      if (menuItem.classList.contains('dropdown-item')) {
        var parentDropdown = menuItem.closest('.dropdown');
        if (parentDropdown) {
          parentDropdown.classList.add('active');
        }
      }
    }
  });

  // Toggle contact overview
  var fastContactButton = document.querySelector('.fast-contact-button');
  if (fastContactButton) {
    fastContactButton.addEventListener('click', function() {
      var contactOverview = document.querySelector('.contact-overview');
      if (contactOverview) {
        contactOverview.classList.toggle('show');
      }
    });
  }
});